import styles from './VacancyComponent.module.scss';
import Image from 'next/image';

const VacancyPilotComponent = () => {
  return (
    <section className="container">
      <div className={styles.vacancyPage}>
        <div className={styles.vacancyPageHead}>
          <Image
            src={'/img/jobs/jobs-img1.png'}
            alt={'logo'}
            width={56}
            height={56}
          />
          <h2>Pilot | The Hera Group</h2>
        </div>
        <div className={styles.vacancyPageContent}>
          <div className={styles.vacancyPageBlock}>
            <div className={styles.vacancyPageBlockDescription}>
              Send resumes to:{' '}
              <a
                href="mailto:careers@heraflight.com"
                className={styles.emailLink}
              >
                careers@heraflight.com
              </a>
            </div>
          </div>

          <div className={styles.vacancyPageBlock}>
            <div className={styles.vacancyPageBlockTitle}>Summary</div>
            <div className={styles.vacancyPageBlockDescription}>
              If you are a pilot who likes to fly, enjoys customer interaction
              and strives to complete the mission then we would like to speak to
              you. We are a company founded by pilots and are aware of the
              concerns of professional aviators. We strive to keep our company
              and employees moving forward and retaining our flight crews is a
              top priority.
            </div>
          </div>

          <div className={styles.vacancyPageBlock}>
            <div className={styles.vacancyPageBlockTitle}>Job requirements</div>
            <div className={styles.vacancyPageBlockDescription}>
              • Superior Logistics skills <br />
              • Excellent Leadership and Excellent Management skills. <br />
              • Be a person that requires little guidance to complete
              international trips to multiple countries per day. <br />
              • Self starter <br />
              • Great customer service skills. <br />
              • Current passport. <br />
              • 8 on/ 6 off rotation <br />
              • Benefits, per diem, etc. <br />
            </div>
          </div>

          <div className={styles.vacancyPageBlock}>
            <div className={styles.vacancyPageBlockTitle}>Minimums</div>
            <div className={styles.vacancyPageBlockDescription}>
              • Captains- ATP License, 4000 Hrs TT, 2500 PIC, 2500 ME, 1000 Jet,
              250 Hrs in type Preferred but not required. <br />
              • First Officers - 1500 hours total 250 multi <br />
              • Previous part 135 experience preferred <br />
              • No Country entering background issues <br />
              • Must be able to pass a pre-employment drug test as well as a
              10-year criminal background check <br />• Must be able to pass DMV
              check and have valid driver’s license <br />
              • Employment verification Required <br />
              • Ability to pass simulator training as PIC <br />
              • Ability to pass FAR Part 135.293 and 135.299 check rides <br />
              • No history of accidents, incidents or FAA action within the last
              5 years <br />
              • Proficient with strong English communication skills <br />
              • Proficient with computer and iPad applications <br />• Legal
              right to live and work in the United States Aviation <br />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VacancyPilotComponent;
